import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map } from 'rxjs/operators';

import { SimplifiedProductMatchService } from './simplified-product-match';

export const campaignLandingCanMatch: CanMatchFn = (_route, segments) => {
  const segment = segments[0]?.path ?? '';
  return inject(SimplifiedProductMatchService)
    .match(segment)
    .pipe(map(product => product !== null));
};
